// import $ from "jquery";
import baseClass from "./base";
import "./jquery.crypt";


var PLUGINNUMBER = function () {

	// ============================================================================
	this.format_number = function (n, d, dp, hs) {
		if (d == undefined) d = 2;
		if (dp == undefined) dp = get_dec_point();
		if (hs == undefined) hs = get_thousands_sep();
		
		return $.number( n, d, dp, hs );
	};

	this.setpreparednumber = function(obj, isblur){
		if (isblur == undefined) isblur = false;
		var newval = preparenumber(obj.val());
		var isInt = obj.attr('data-isint');
		isInt = (isInt != undefined && isInt == '1') ? 1 : 0;
		var newvalt = (isInt) ? parseInt(newval) : parseFloat(newval);
		var minv = parseFloat(obj.attr('data-min'));
		var maxv = parseFloat(obj.attr('data-max'));
		if (isblur)
		{
			if (newvalt != undefined && !isNaN(newvalt)) {
				if (minv != undefined && !isNaN(minv) && minv > newvalt) newvalt = minv;
				if (maxv != undefined && !isNaN(maxv) && maxv < newvalt) newvalt = maxv;
				obj.val(newvalt);
			} else
			{
				obj.val('');
			}
		} else
		{
			if (newvalt != undefined && !isNaN(newvalt))
			{
				// if (minv != undefined && !isNaN(minv) && minv > newvalt) newval = minv;
				// if (maxv != undefined && !isNaN(maxv) && maxv < newvalt) newval = maxv;
				obj.val(newval);
			}
		}
	}
}


$.number = function( number, decimals, dec_point, thousands_sep ){
		// Set the default values here, instead so we can use them in the replace below.
		thousands_sep	= (typeof thousands_sep === 'undefined') ? ',' : thousands_sep;
		dec_point		= (typeof dec_point === 'undefined') ? '.' : dec_point;
		decimals		= !isFinite(+decimals) ? 0 : Math.abs(decimals);
		
		// Work out the unicode representation for the decimal place and thousand sep.	
		var u_dec = ('\\u'+('0000'+(dec_point.charCodeAt(0).toString(16))).slice(-4));
		var u_sep = ('\\u'+('0000'+(thousands_sep.charCodeAt(0).toString(16))).slice(-4));
		
		// Fix the number, so that it's an actual number.
		number = (number + '')
			.replace('\.', dec_point) // because the number if passed in as a float (having . as decimal point per definition) we need to replace this with the passed in decimal point character
			.replace(new RegExp(u_sep,'g'),'')
			.replace(new RegExp(u_dec,'g'),'.')
			.replace(new RegExp('[^0-9+\-Ee.]','g'),'');
		
		var n = !isFinite(+number) ? 0 : +number,
		    s = '',
		    toFixedFix = function (n, decimals) {
		        var k = Math.pow(10, decimals);
		        return '' + Math.round(n * k) / k;
		    };
		
		// Fix for IE parseFloat(0.55).toFixed(0) = 0;
		s = (decimals ? toFixedFix(n, decimals) : '' + Math.round(n)).split('.');
		if (s[0].length > 3) {
		    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, thousands_sep);
		}
		if ((s[1] || '').length < decimals) {
		    s[1] = s[1] || '';
		    s[1] += new Array(decimals - s[1].length + 1).join('0');
		}
		return s.join(dec_point);
	}
;



function get_dec_point()
{
	return ($('#dec_point_format').size) ? $('#dec_point_format').attr('data') : '.';
}

function get_thousands_sep()
{
	return ($('#thousands_sep_format').size) ? $('#thousands_sep_format').attr('data') : '';
}


function preparenumber(n)
{
	n = '' + n;
	n = n.replace(/[^\d,\.-]/g, '');
	n = n.replace(/[,\.]/g, '.');
	
	return n;
}


// ------------------------------------
baseClass.OnReadyArrAdd(function(){	
	$('.js_anynumber').off('keyup').on('keyup', function()
	{
		pluginNumber.setpreparednumber($(this));
	});	
	$('.js_anynumber').off('mouseup').on('mouseup', function()
	{
		pluginNumber.setpreparednumber($(this));
	});	
	$('.js_anynumber').off('blur').on('blur', function()
	{
		pluginNumber.setpreparednumber($(this), true);
	});	
	$('.js_anynumber').off('focus').on('focus', function()
	{
		pluginNumber.setpreparednumber($(this));
	});	
} );

var pluginNumber = new PLUGINNUMBER();

export default pluginNumber;
